export function trimLeft(s, charlist) {
  return s.replace(new RegExp("^[" + charlist + "]+"), "");
}

export function stringToBoolean(stringOrBoolean) {
  if (typeof stringOrBoolean == typeof true) return stringOrBoolean;
  return stringOrBoolean === "true";
}
